import {
  Box,
  List,
  StatusLabel,
  StatusLabelTypes,
  Text,
} from '@factorialco/deprecated-design-system'
import { AtsFileOptionsErrorsEnum, AtsUploadCvFileFragment } from 'generated/resources/graphql'

import DocumentType from 'modules/core/components/DocumentType'
import i18n from 'modules/core/lib/i18n'

interface Props {
  title: string
  description: string
  status: 'in_progress' | 'cancelled' | 'error'
  files: AtsUploadCvFileFragment[]
}

export const FilesList = ({ title, description, status, files }: Props) => {
  const statusLabel =
    status === 'in_progress'
      ? i18n.t('ats.candidates.upload_resumes.status.in_progress')
      : status === 'cancelled'
      ? i18n.t('ats.candidates.upload_resumes.status.cancelled')
      : i18n.t('ats.candidates.upload_resumes.status.failed')

  const statusType: StatusLabelTypes =
    status === 'in_progress' ? 'info' : status === 'cancelled' ? 'warning' : 'critical'

  return (
    <Box gap="s8">
      <StatusLabel type={statusType}>{statusLabel}</StatusLabel>
      <Box gap="s4" paddingBottom="s8">
        <Text.Normal color="grey1000" weight="medium">
          {title}
        </Text.Normal>
        <Text.Normal>{description}</Text.Normal>
      </Box>
      <List>
        {files.map((file, key) => (
          <List.Item key={`upload-file${key}`}>
            <Box alignItems="center" flexGrow flexDirection="row" gap="s16" minWidth="s0">
              <DocumentType mimetype={file.file.contentType} />
              <Box overflowX="hidden">
                <Text.Normal weight="medium" ellipsis>
                  {file.file.filename}
                </Text.Normal>
                {file.processingError && (
                  <Text.Normal color="radicalRed1000" size="200">
                    {errorCodeToText(file.processingError)}
                  </Text.Normal>
                )}
              </Box>
            </Box>
          </List.Item>
        ))}
      </List>
    </Box>
  )
}

const errorCodeToText = (code: AtsFileOptionsErrorsEnum) => {
  switch (code) {
    case 'candidate_data_not_found':
    case 'file_conversion_failed':
    case 'text_extraction_failed':
      return i18n.t('ats.candidates.upload_resumes.errors.unable_to_extract_data')
    case 'unsupported_format':
      return i18n.t('ats.candidates.upload_resumes.errors.unsupported_format')
    case 'candidate_creation_failed':
    default:
      return i18n.t('ats.candidates.upload_resumes.errors.candidate_creation_failed')
  }
}
